// date format as DD.MM.YY
import dayjs from 'dayjs';

export function formatDateToDDMMYY(date: string | Date): string {
    return dayjs(date).format('DD.MM.YY');
}
